import { render, staticRenderFns } from "./IComment.vue?vue&type=template&id=55d31afc&"
import script from "./IComment.vue?vue&type=script&lang=ts&"
export * from "./IComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports